<template>
  <div class='dialog_'>
    <div class='dialog_box_' :style='boxstyle'>
      <div>
	<div class='icon small' style="float: right;" @click="$emit('cancel')">
	  <img src="/files/backend/icons/cancel.svg" />
	</div>
	<div class='dialog_box_title_'>{{title}}</div>
      </div>
      <form @submit.prevent="$emit('submit',$event)" style="clear: both">
	<div class='dialog_box_content_'>
	  <slot></slot>
	</div>
	<div class='dialog_box_actions_'>
	  <button type="submit" v-if="isform">{{submit_text}}</button>
	  <button v-if="save_in_place" @click="$emit('save_in_place')" type="button">Save In Place</button>
	  <button type="button" @click="$emit('cancel')">Cancel</button>
	</div>
      </form>
    </div>
  </div>
</template>

<script>

export default {
    props: {
	title: String,
	isform: Boolean,
	save_in_place: Boolean,
	boxstyle: {
	    type: Object,
	    default: function() { return {}}
	},
	submit_text: {
	    type: String,
	    default: "Submit",
	}
    },
    data: function() { return {
    }},
    mounted: function() {
	this.$emit('mounted')
    },
    methods: {
    }
}

</script>

<style scoped>
.dialog_ {
    position: fixed;
    background-color: rgba(255,255,255,0.75);
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1001;
    flex-direction: column;  
}
.dialog_box_ {
    background-color: white;
    padding: 30px;
    box-shadow: 0 0 10px rgba(0,0,0,0.5);
    max-height: 96vh;
    max-width: 96vw;
    overflow: auto
}
.dialog_box_title_ {
    font-weight: bold;
    text-transform: uppercase;
    text-align: center;
    white-space: nowrap;
    padding: 5px 50px 5px 50px;
    font-size: 1.2em;
}
.dialog_box_actions_ {
    margin-top: 30px;
    text-align: center;
}
.dialog_box_actions_ button {
    margin: 0 5px;
}

</style>
